'use client';

import { FC } from 'react';

export const WlasBillingTab: FC = () => null;
